/**
 * Application environment values
 */
export enum AppEnvironment {
  LOCALHOST = 'localhost',
  DEV = 'development',
  TEST = 'test',
  PROD = 'production',
}
